let Youtube = {
  type: 'yt',
  player: undefined,
  ready: false,
  paused: undefined,
  onPlay: undefined,
  onPause: undefined,
  onEnd: undefined,
  onStatusChange: undefined,
  isVideo: true,
  shareUrl: undefined
};

let previousState = undefined;
let YT = undefined;

let currentTrack = undefined;

Youtube.load = ({onEndCb, onPlayCb, onPauseCb, onStatusChangeCb}) => {

  Youtube.onPlay = onPlayCb;
  Youtube.onPause = onPauseCb;
  Youtube.onEnd = onEndCb;
  Youtube.onStatusChange = onStatusChangeCb;

  let tag = document.createElement('script');
  tag.src = "//www.youtube.com/iframe_api";
  let firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
};

Youtube.onPlayerReady = (event) => {
  Youtube.ready = true;
  YT = window.YT;
};

Youtube.onPlayerStateChange = (event) => {

  if (event.data === YT.PlayerState.PLAYING) {
    Youtube.paused = false;
    if (!Youtube.shareUrl) {
      Youtube.shareUrl = Youtube.player.getVideoUrl().replace(/t=\d+&/,'');
      currentTrack.shareUrl = Youtube.shareUrl;
    }
  }

  if (event.data === YT.PlayerState.PAUSED) {
    Youtube.paused = true;
  } 

  if (event.data === YT.PlayerState.ENDED) {
    Youtube.paused = true;
    Youtube.onEnd();
  }

  if (event.data === YT.PlayerState.UNSTARTED) {
    Youtube.paused = true;
    Youtube.onPlay();
  }

  if (previousState !== YT.PlayerState.BUFFERING && event.data === YT.PlayerState.PLAYING) {
    Youtube.onPlay();
  }

  Youtube.onStatusChange(event.data);

  previousState = event.data;
  
};

Youtube.loadTrack = (track) => {
  if (Youtube.ready)  {
    currentTrack = track;
    let albumCover = 'https://i1.ytimg.com/vi/'+track.id+'/mqdefault.jpg';
    currentTrack.img = albumCover;
    Youtube.shareUrl = undefined;
    Youtube.player.loadVideoById(track.id);
  }
}

Youtube.play = () => {

  if (Youtube.ready) {
    Youtube.player.playVideo();
  }

}

Youtube.pause = (track) => {

  if (Youtube.ready) {
    Youtube.player.pauseVideo();
  }

}

window.onYouTubeIframeAPIReady = () => {

  //https://developers.google.com/youtube/player_parameters

  Youtube.player = new window.YT.Player('youtubePlayer', {
    height: '390',
    width: '640',
    origin: 'https://www.youtube.com',
    playerVars: { 
      playsinline: 1, 
      autoplay: 0, 
      controls: 1, 
      html5: 1 
    },
    events: {
      onReady: Youtube.onPlayerReady,
      onStateChange: Youtube.onPlayerStateChange
    }
  });

};

module.exports = Youtube


// WEBPACK FOOTER //
// ./src/js/services/youtube.js